
    import { defineComponent } from 'vue';
    import { store } from '@/store';
    import { IonBackButton, IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/vue';
    import BasePanel from '@/components/BasePanel.vue';
    import OrderService from "@/services/order.service";
    import BaseLoader from "@/components/BaseLoader.vue";

    export default defineComponent({
        name      : 'PayLater',
        components: {
            BaseLoader,
            IonContent,
            BasePanel,
            IonPage,
            IonTitle,
            IonButtons,
            IonBackButton,
            IonHeader,
            IonToolbar,
        },
        data() {
            return {
                BackIcon: require('@/assets/images/icons/back.svg'),
                loading : false as any,
            };
        },
        methods : {
            async toPayLaterSuccess() {
                this.loading = true;
                this.loading = await OrderService.sendPaymentMethod('14');
            },
        },
        computed: {
            order() {
                return store.getters['order/getSelectedOrder'];
            },
        }
    });
